const messages = {
  sk: {
    reactMuiTables: {
      selected: 'vybrané',
      filterhide: 'Skryť filter',
      filtershow: 'Zobraziť filter',
      refresh: 'Obnoviť',
      filter: {
        actions: {
          search: 'Vyhľadávanie',
          resetFilter: 'Zmazať filter',
          addCondition: 'Pridať podmienku',
        },
      },
      standardOperators: {
        equals: 'rovná sa',
        contains: 'obsahuje',
        between: {
          label: 'medzi',
          from: 'od',
          to: 'do',
        },
        oneOf: 'jeden z',
      },
      labelRowsPerPage: 'Počet riadkov na stránku:',
    },
  },
};
export default messages;
